import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useT } from "@/context/I18nContext";
import { toast } from "sonner";
import { Plus, Save, Trash2, MapPin } from "lucide-react";

export default function RegionsManager() {
  const { t } = useT();
  const [regions, setRegions] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [newName, setNewName] = useState({ name: "", name_hy: "" });

  const load = () => {
    api.get("/regions").then(r => setRegions(r.data));
    api.get("/chapters").then(r => setChapters(r.data));
  };
  useEffect(load, []);

  const add = async () => {
    if (!newName.name.trim()) return toast.error(t("Name is required", "Անունը պարտադիր է"));
    await api.post("/regions", newName);
    setNewName({ name: "", name_hy: "" });
    toast.success(t("Region added", "Տարածաշրջանն ավելացվեց"));
    load();
  };
  const save = async (r) => {
    await api.put(`/regions/${r.region_id}`, { name: r.name, name_hy: r.name_hy });
    toast.success(t("Saved", "Պահպանված է"));
  };
  const remove = async (r) => {
    try { await api.delete(`/regions/${r.region_id}`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || t("Failed", "Ձախողվեց")); }
  };
  const edit = (id, k, v) => setRegions(rs => rs.map(r => r.region_id === id ? { ...r, [k]: v } : r));

  return (
    <Card className="clay-card p-6 mt-4 space-y-4" data-testid="regions-manager">
      <p className="text-sm text-muted-foreground">{t("Regional admins only see chapters and users inside their region. Assign each chapter a region from the Chapters page.", "Տարածաշրջանային ադմինները տեսնում են միայն իրենց տարածաշրջանի մասնաճյուղերն ու օգտատերերին։")}</p>
      {regions.map(r => (
        <div key={r.region_id} className="flex flex-wrap items-center gap-2" data-testid={`region-row-${r.region_id}`}>
          <MapPin size={14} className="text-muted-foreground"/>
          <Input className="w-48" value={r.name} onChange={e => edit(r.region_id, "name", e.target.value)} data-testid={`region-name-${r.region_id}`}/>
          <Input className="w-48" value={r.name_hy || ""} onChange={e => edit(r.region_id, "name_hy", e.target.value)} placeholder="Հայերեն"/>
          <span className="text-xs text-muted-foreground">{chapters.filter(c => c.region_id === r.region_id).length} {t("chapters", "մասնաճյուղ")}</span>
          <Button size="sm" variant="ghost" onClick={() => save(r)} data-testid={`region-save-${r.region_id}`}><Save size={14}/></Button>
          <Button size="sm" variant="ghost" className="text-[hsl(0,65%,55%)]" onClick={() => remove(r)} data-testid={`region-delete-${r.region_id}`}><Trash2 size={14}/></Button>
        </div>
      ))}
      <div className="flex flex-wrap items-center gap-2 pt-2 border-t">
        <Input className="w-48" value={newName.name} onChange={e => setNewName({ ...newName, name: e.target.value })} placeholder={t("New region", "Նոր տարածաշրջան")} data-testid="region-new-name"/>
        <Input className="w-48" value={newName.name_hy} onChange={e => setNewName({ ...newName, name_hy: e.target.value })} placeholder="Հայերեն"/>
        <Button size="sm" className="btn-pill" onClick={add} data-testid="region-add-btn"><Plus size={14} className="mr-1"/>{t("Add", "Ավելացնել")}</Button>
      </div>
    </Card>
  );
}
